// extracted by mini-css-extract-plugin
export default {"customImage":"BackGroundLogo_customImage__v5sfZ"};